import { useState, useRef } from "react";
import { AuditIcon } from "ui/icons";
import { useSelector } from "react-redux";
import { MoreVertIcon } from "ui/icons";
import { OpenQueryIcon, RespondedQueryIcon, ResolvedQueryIcon, DeviationIcon } from "ui/icons";
import Tooltip from "@mui/material/Tooltip";
import { arrayHaveCommonItems } from "util/helpers";
import styles from "./element_menu.module.css";
import strings from "strings";

export default function ElementMenu(props) {
  const {
    toggleHistory,
    renderFieldComponent,
    selected_audit_icon,
    setQueryModalData,
    _updateFieldFlag,
    showHistory,
    field,
    hideElementMenu,
    onUpdate,
    read_only = false,
  } = props;
  const _toggleHistory = () => toggleHistory({ field_id: field.id });
  const [showMenu, setShowMenu] = useState(true);
  const permissions = useSelector((state) => state.user.userData.permissions);

  const dropMenuRef = useRef(null);

  const menu_show_data_complete = true;
  const menu_show_query =
    (Object.keys(field.query || {}).length && arrayHaveCommonItems(permissions, ["respond_query", "resolve_query"])) ||
    permissions.includes("start_query");
  const menu_show_monitored = permissions.includes("set_monitored_flag");
  const menu_show_data_qa = permissions.includes("set_qc_flag");
  const menu_show_change_history = permissions.includes("crf_change_history");
  const menu_show_set_missing = !read_only && !field?.value_obj?.missing;

  const query = field.query;
  const query_icon_open_style = [styles.query_icon].join(" ");
  const query_icon_resolved_style = [styles.query_icon, styles.query_icon_resolved].join(" ");
  const query_icon_responded_style = [styles.query_icon, styles.query_icon_responded].join(" ");
  const get_query_icon = (query, handleClick) => {
    if (arrayHaveCommonItems(permissions, ["view_query_status", "start_query", "respond_query", "resolve_query"])) {
      if (query.status === "resolved") {
        return (
          <div className={styles.query_icon} onClick={handleClick}>
            <Tooltip title={strings.query_resolved}>
              <ResolvedQueryIcon fontSize="16px" />
            </Tooltip>
          </div>
        );
      } else if (query.status === "responded" || query.status === "action") {
        return (
          <div className={styles.query_icon} onClick={handleClick}>
            <Tooltip title={strings.query_responded}>
              <RespondedQueryIcon fontSize="16px" />
            </Tooltip>
          </div>
        );
      } else if (query.status === "open" || query.status === "okay") {
        return (
          <div className={styles.query_icon} onClick={handleClick}>
            <Tooltip title={strings.query_open}>
              <OpenQueryIcon fontSize="16px" />
            </Tooltip>
          </div>
        );
      } else return "";
    } else return "";
  };

  const get_flag_icons = () => {
    let ret = [];

    if (field.value_obj?.deviation) {
      ret.push(
        <div className={styles.deviation_icon_wrapper}>
          <Tooltip title={strings.deviation}>
            <DeviationIcon fontSize="16px" />
          </Tooltip>
        </div>
      );
    }

    if (
      field.value_obj?.flags?.constructor === Array &&
      field.value_obj?.flags?.includes("site_signoff") &&
      (permissions?.includes("set_pi_signed_flag") || permissions?.includes("view_pi_signed_flag"))
    ) {
      if (field.value_obj?.flags?.includes("resite_signoff")) {
        ret.push(
          <div className={styles.letter_icon_wrapper}>
            <div className={styles.re_letter_icon}>
              <Tooltip title={strings.re_site_signoff}>S</Tooltip>
            </div>
          </div>
        );
      } else if (field.value_obj?.flags?.includes("site_signoff")) {
        ret.push(
          <div className={styles.letter_icon_wrapper}>
            <div className={styles.letter_icon}>
              <Tooltip title={strings.field_site_signoff}>S</Tooltip>
            </div>
          </div>
        );
      }
    }

    if (
      field.value_obj?.flags?.constructor === Array &&
      field.value_obj?.flags?.includes("monitored") &&
      (permissions.includes("set_monitored_flag") || permissions.includes("view_monitored_flag"))
    ) {
      if (field.value_obj?.flags?.includes("remonitored")) {
        ret.push(
          <div className={styles.letter_icon_wrapper}>
            <div className={styles.re_letter_icon}>
              <Tooltip title={strings.re_monitor}>M</Tooltip>
            </div>
          </div>
        );
      } else if (field.value_obj?.flags?.includes("monitored")) {
        ret.push(
          <div className={styles.letter_icon_wrapper}>
            <div className={styles.letter_icon}>
              <Tooltip title={strings.field_monitored}>M</Tooltip>
            </div>
          </div>
        );
      }
    }

    if (
      field.value_obj?.flags?.constructor === Array &&
      field.value_obj?.flags?.includes("qa") &&
      (permissions.includes("set_qc_flag") || permissions.includes("view_qc_flag"))
    ) {
      if (field.value_obj?.flags?.includes("reqa")) {
        ret.push(
          <div className={styles.letter_icon_wrapper}>
            <div className={styles.re_letter_icon}>
              <Tooltip title={strings.re_qa}>Q</Tooltip>
            </div>
          </div>
        );
      } else if (field.value_obj?.flags?.includes("qa")) {
        ret.push(
          <div className={styles.letter_icon_wrapper}>
            <div className={styles.letter_icon}>
              <Tooltip title={strings.field_qa}>Q</Tooltip>
            </div>
          </div>
        );
      }
    }

    return ret;
  };

  const menu_items_exist =
    menu_show_query || menu_show_monitored || menu_show_data_qa || menu_show_change_history || menu_show_set_missing;

  if (hideElementMenu) {
    return;
  }
  return (
    <div className={styles.wrapper}>
      {get_flag_icons(field)}

      {query?.id ? (
        <div className={styles.query_icon_wrapper}>{get_query_icon(query, () => setQueryModalData(field))}</div>
      ) : null}

      <div className={styles.hover_menu_wrapper}>
        {menu_items_exist ? (
          <MoreVertIcon onClick={() => setShowMenu(!showMenu)} onMouseEnter={() => setShowMenu(true)} />
        ) : null}
        {showMenu ? (
          <div className={styles.hover_menu_content} ref={dropMenuRef}>
            {menu_show_query ? (
              <div className={styles.menu_button} onClick={() => setQueryModalData(field)}>
                Query
              </div>
            ) : null}
            {menu_show_change_history ? (
              <div className={styles.menu_button} onClick={_toggleHistory}>
                Change history
              </div>
            ) : null}
            {menu_show_set_missing ? (
              <div
                className={styles.menu_button}
                onClick={() => {
                  onUpdate({ missing: true, flags: field.value_obj?.flags || [] });
                  setShowMenu(false);
                }}
              >
                Set data as missing
              </div>
            ) : null}

            {menu_show_monitored && field.value_obj?.data_id ? (
              field?.value_obj?.flags?.constructor === Array &&
              field?.value_obj?.flags?.includes("monitored") &&
              !field?.value_obj?.flags?.includes("remonitored") ? (
                <div
                  className={styles.menu_button}
                  onClick={() => {
                    setShowMenu(false);
                    _updateFieldFlag("monitored", false);
                  }}
                >
                  Remove Monitored Flag
                </div>
              ) : (
                <div
                  className={styles.menu_button}
                  onClick={() => {
                    setShowMenu(false);
                    _updateFieldFlag("monitored", true);
                  }}
                >
                  Set Monitored Flag
                </div>
              )
            ) : null}
            {menu_show_data_qa && field.value_obj?.data_id ? (
              field.value_obj?.flags?.constructor === Array &&
              field.value_obj?.flags?.includes("qa") &&
              !field.value_obj?.flags?.includes("reqa") ? (
                <div
                  className={styles.menu_button}
                  onClick={() => {
                    setShowMenu(false);
                    _updateFieldFlag("qa", false);
                  }}
                >
                  Remove QC Flag
                </div>
              ) : (
                <div
                  className={styles.menu_button}
                  onClick={() => {
                    setShowMenu(false);
                    _updateFieldFlag("qa", true);
                  }}
                >
                  Set QC Flag
                </div>
              )
            ) : null}
          </div>
        ) : null}
      </div>
      {showHistory ? (
        <div>
          <AuditIcon onClick={_toggleHistory} selected={selected_audit_icon} />
        </div>
      ) : null}
    </div>
  );
}
